import * as types from "./types";

const mutations = {
    [types.LOADING_DOCUMENT](state, value) {
        state.loading = value;
    },
    [types.FILE_SHARING](state, file) {
        state.file = file;
    }
};

export default mutations;